import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'lib-gung-loading-modal',
    templateUrl: './gung-loading-modal.component.html',
    styleUrl: './gung-loading-modal.component.scss',
    standalone: false
})
export class GungLoadingModalComponent {
  loadingText: string;

  constructor(public activeModal: NgbActiveModal) { }
}
